/* eslint-disable indent */
import axios, { AxiosResponse } from 'axios';
import store from '@/store';
import RootTypes from '@/store/types/root';

const tokenKey = '_central_commpix_token';
const tokenExpiryKey = '_central_commpix_token_expiry';
const URL: string | undefined = `${process.env.VUE_APP_URL_PAYMENTS_API}/api`;

const httpCommpix = axios.create({
  baseURL: `${URL}`,
});
// Add a request interceptor
httpCommpix.interceptors.request.use(
  config => {
    store.commit(RootTypes.mutations.SET_START_PROCESS);
    const token = localStorage.getItem(tokenKey);
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers?.Authorization;
    }
    return config;
  },
  error => {
    store.commit(RootTypes.mutations.SET_END_PROCESS);
    return Promise.reject(error);
  }
);

// Add a response interceptor
httpCommpix.interceptors.response.use(
  (response: AxiosResponse) => {
    store.commit(RootTypes.mutations.SET_END_PROCESS);
    return response;
  },
  async error => {
    store.commit(RootTypes.mutations.SET_END_PROCESS);

    // Extract error message
    const errorDetails = error.response?.data?.details;
    const errorMessage = Array.isArray(errorDetails) && errorDetails.length > 0
      ? errorDetails[0]
      : error;

    return Promise.reject(errorMessage);
  }
);

// Get auth data for commpix

// export function getAuthPayload(): {
//   companyId: string | null | undefined;
//   commerceId: string | null | undefined;
//   branchId: string | null | undefined;
// } {
//   const auth = ((store.state as unknown) as { authModule: AuthState }).authModule;
//   const activeCompanyUser = auth?.currentUser?.company_users?.[0];
//   return {
//     companyId: activeCompanyUser?.company_id,
//     commerceId: activeCompanyUser?.commerce_id,
//     branchId: activeCompanyUser?.branch_id,
//   };
// }

// Post including auth data function

// export async function postWithAuthPayload<T = unknown>(
//   url: string,
//   data: Record<string, unknown> = {}
// ): Promise<AxiosResponse<T>> {
//   const payload = { ...getAuthPayload(), ...data, };
//   return httpCommpix.post<T>(url, payload);
// }

export { httpCommpix, URL, tokenKey, tokenExpiryKey };
